export default "__VITE_ASSET__CKofeVd7__"